module.exports = __webpack_public_path__ + "img/square-m.ded3ce12.svg";